import "./Flex.scss";

interface Props {
  children;
  gap?: number;
  direction?: "row" | "column" | "row-reverse" | "column-reverse";
  grow?: number;
  alignItems?:
    | "normal"
    | "stretch"
    | "center"
    | "flex-start"
    | "flex-end"
    | "start"
    | "end"
    | "baseline"
    | "initial"
    | "inherit";
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "initial"
    | "inherit";
  wrap?: "nowrap" | "wrap" | "wrap-reverse" | "initial" | "inherit";
  basis?: string | "auto" | "initial" | "inherit";
  fullWidth?: boolean;
  style?: Record<string, any>;
  className?: string;
}

export const Flex = ({
  children,
  direction = "row",
  gap = 0,
  grow = 0,
  alignItems = "normal",
  justifyContent = "flex-start",
  wrap = "wrap",
  fullWidth = false,
  basis = "auto",
  style = {},
  className = "",
}: Props) => {
  return (
    <div
      style={{
        gap,
        flexWrap: wrap,
        alignItems,
        justifyContent,
        flexDirection: direction,
        flexGrow: grow,
        flexBasis: basis,
        width: fullWidth ? "100%" : "auto",
        ...style,
      }}
      className={`flex ${className}`}
    >
      {children}
    </div>
  );
};

export default Flex;
